// src/components/Auth/RequestSuccessPage.tsx
import React from 'react';
import { CheckCircle, Mail, ArrowRight } from 'lucide-react';

interface RequestSuccessPageProps {
  email?: string;
  isWaitlisted?: boolean;
  onBackToLogin: () => void;
}

export function RequestSuccessPage({ 
  email = '', 
  isWaitlisted = false,
  onBackToLogin 
}: RequestSuccessPageProps) {
  return (
    <>
      {/* Header */}
      <div className="px-6 flex flex-col justify-center border-b border-gray-200" style={{ height: '90px' }}>
        <h2 className="text-2xl font-regular text-gray-900">
          {isWaitlisted ? 'Added to Waitlist!' : 'Invite Sent!'}
        </h2>
      </div>
      {/* <div className="px-6 flex flex-col items-center justify-center text-center border-b border-gray-200" style={{ height: '90px' }}>
        <h2 className="text-xl font-semibold text-gray-900">
          {isWaitlisted ? 'Added to Waitlist!' : 'Invite Sent!'}
        </h2>
      </div> */}

      {/* Content */}
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-center">
          <div className="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full">
            <Mail size={24} className="text-blue-600" />
          </div>
        </div>

        <div className="text-center space-y-3">
          {isWaitlisted ? (
            <>
              <p className="text-gray-800">
                You've been added to our waitlist!
              </p>
              <p className="text-gray-600 text-sm">
                We'll send an invite to <span className="font-semibold">{email}</span> as soon as a spot opens up.
              </p>
              <p className="text-gray-600 text-sm">
                The current wait time is approximately 24-48 hours.
              </p>
            </>
          ) : (
            <>
              {/* <p className="text-gray-800">
                Your invite code has been sent!
              </p> */}
              <p className="text-gray-600 text-sm">
                We've sent your exclusive invite code to <span className="font-semibold">{email}</span>.
              </p>
              <p className="text-gray-600 text-sm">
                The code is valid for 48 hours.
              </p>
            </>
          )}
        </div>

        {/* Continue Button */}
        <button
          onClick={onBackToLogin}
          className="w-full py-2 px-4 rounded-md text-white font-medium bg-blue-600 hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
        >
          <span>{isWaitlisted ? 'Return to Home' : 'Enter Invite Code'}</span>
          <ArrowRight size={18} />
        </button>

        <div className="text-xs text-gray-500 text-center">
          Didn't receive an email? Check your spam folder or <a href="mailto:21species@gmail.com" className="text-blue-600 hover:underline">contact support</a>.
        </div>
      </div>
    </>
  );
}